<template>
	<div class="forgot">
		<div class="forgot-sub-cont">
			<div class="header5">Hi There!</div>
			<div class="header2">Forgot your password?</div>
			<br />
			<div v-if="!sentEmail" class="forgot-q-cont">
				<form class="forgot-form-container" action="#">
					<InputBox placeHolder="Please Enter Your Email" v-model="email" />
					<div class="mid-sec">
						<Button title="Submit" :onClick="submit" />
					</div>
				</form>
			</div>
			<div v-else class="email-send">
				<div>
					If we found an account associated with that email, <br />
					we've sent password reset instructions. Please check your inbox.
					<br /><br />
					Still having trouble logging in? Call us at 847-790-5028.
				</div>
			</div>
			<div class="log-cont">
				<div class="paragraph back-forgot">Back to <span @click="goLogin">Login!</span></div>
			</div>
		</div>
	</div>
</template>

<script>
// import { Prop } from "vue-property-decorator";
import InputBox from "@/components/ui/InputBox.vue";
import Button from "@/components/ui/Button.vue";
import { AUTH_FORGOT } from "@/store/constants";

import localData from "@/store/utils/localdata";
export default {
	name: "forgot",
	title: "Forgot Password",
	components: {
		InputBox,
		Button,
	},
	data() {
		return {
			email: "",
			sentEmail: false,
		};
	},
	mounted() {
		this.sentEmail = false;
	},
	methods: {
		async submit() {
			if (!this.email) {
				this.$toast.open({
					message: "Missing fields",
					position: "top",
					type: "error",
				});
			}
			const user = {
				email: this.email,
			};
			try {
				const result = await this.$store.dispatch(AUTH_FORGOT, user);
				// this.setSentEmail = true;
				if (result && result.success) this.setSentEmail(true);
			} catch (ex) {
				this.$toast.open({
					message: "Error happened when submitting email",
					position: "top",
					type: "error",
				});
			}
		},
		resetFrogotPasswordForm() {
			this.setSentEmail(false);
		},
		setSentEmail(e) {
			this.sentEmail = e;
		},
		goLogin() {
			this.$router.push({ name: "Login" });
		},
	},
};
</script>

<style scoped lang="scss">
.forgot {
	background: var(--dark-blue);
	height: 100%;
	// padding-bottom: 5vw;
	width: 100%;
	.email-send {
		background: var(--dark-blue);
		text-align: center;
		display: flex;
		font-style: normal;
		font-weight: normal;
		font-size: 36px;
		line-height: 65px;
		color: var(--white);
		padding: 5rem 0 1rem;
	}
	.forgot-sub-cont {
		padding: 5vw;
		display: flex;
		flex-direction: column;
		align-items: center;
		.forgot-q-cont {
			width: 710px;
		}
		.header5 {
			color: var(--accent);
			font-size: 18px;
			margin-bottom: 20px;
		}
		.header2 {
			color: var(--white);
			font-size: 51px;
			line-height: 51px;
		}
		.paragraph {
			width: 500px;
			text-align: center;
			margin: auto;
			color: var(--white);
			opacity: 0.5;
			margin-top: 20px;
		}
		.forgot-form-container {
			margin-top: 2vw;
			width: 100%;
			display: flex;
			flex-direction: row;
			align-items: center;
			.mid-sec {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				.button {
					height: 65px;
					border-radius: 40px;
				}
				.forgot {
					text-align: left;
					margin-bottom: unset;
					color: var(--white);
					opacity: 0.5;
				}
				.forgot:hover {
					color: var(--accent);
					cursor: pointer;
				}
			}
		}
		.back-forgot {
			color: white;
			margin-top: 2px;
			width: 500px;
			margin: auto;
			opacity: 1;
			span {
				font-style: normal;
				font-weight: 500;
				font-size: 18px;
				line-height: 27px;
				text-align: center;
				cursor: pointer;
				color: rgba(80, 205, 243, 1);
			}
			& :hover {
				color: var(--primary);
			}
		}
		.log-cont {
			margin-top: 60px;
		}
		.forgot-register-cont {
			max-width: 500px;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			margin: 0 auto;
			margin-top: 65px;
			margin-bottom: 150px;
			.header5.register {
				padding-bottom: unset;
				margin-bottom: unset;
				color: var(--white);
				font-size: 18px;
			}
		}
	}
}
@media screen and (max-width: 414px) {
	.forgot .forgot-sub-cont {
		.header5 {
			padding-bottom: 4vw;
			font-size: 14px;
			margin-bottom: unset;
		}
		.header2 {
			padding-bottom: 4vw;
			font-size: 36px;
			line-height: 36px;
		}
		.paragraph {
			font-size: 16px;
			line-height: 32px;
			width: unset;
			margin: unset;
			margin-top: 12px;
		}
		.forgot-register-cont {
			.header5.register {
				font-size: 14px;
			}
			.outline.button {
				border-radius: 30px;
				color: var(--white);
				border-color: var(--white);
			}
		}
		.forgot-q-cont {
			width: 100%;
		}
		.forgot-form-container {
			flex-direction: column;
			align-items: unset;
		}
	}
}
</style>
